import styled from 'styled-components';
import { MediaQueryBreakpoints } from '@rockalingua/ui';

export const Container = styled.div`
  display: flex;
  gap: 48px;
  padding: 48px;

  @media only screen and (max-width: ${MediaQueryBreakpoints.sm}px) {
    flex-direction: column;
    padding: 24px;
  }
`;

export const MainContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  max-width: 30%;

  @media only screen and (max-width: ${MediaQueryBreakpoints.sm}px) {
    max-width: 100%;
  }
`;

export const IconsContainer = styled.div`
  flex: 1;
`;
